// Work in cents when combining monetary values from MyInfo.
const toCents = (value) => {
  const number = Number(String(value ?? "").replace(/[$,\s]/g, ""));
  return Number.isFinite(number) ? Math.round((number + Number.EPSILON) * 100) : 0;
};

export const normalizePropertyMoney = (value) => toCents(value) / 100;

export const sumPropertyMoney = (...values) =>
  values.reduce((total, value) => total + toCents(value), 0) / 100;

export const formatPropertyMoneyInput = (value, info) => {
  // Let users type a decimal point or clear the field without moving the caret.
  if (info?.userTyping) return info.input;
  return `$ ${normalizePropertyMoney(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const parsePropertyMoneyInput = (value) =>
  String(value ?? "").replace(/[$,\s]/g, "");
